export default function aqiTranslate(props) {
  let aqiData = ["null", "Good", "Fair", "Moderate", "Poor", "Very poor"];
  let aqiNumbers = props.data;
  let aqiTranslation = aqiData[aqiNumbers];

  return `(${aqiTranslation})`;
}
